export enum REQUEST_TYPE {
  INTAKE = 'intake',
  SUPPORT = 'support',
  REGISTRATION = 'registration',
}
